<template>
  <div>
    <div class="row visible-xs visible-sm">
      <div class="col-xs-12 col-sm-6">
        <div class="faq-group__select-wrap">
          <select
            v-model="localSelectedGroup"
            :style="{ backgroundImage: `url('${selectArrow}')` }"
            class="faq-group__select"
          >
            <option
              v-for="group in groups"
              :value="group"
              :key="group.Id"
            >
              {{ group.Name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <ul class="faq-groups hidden-xs hidden-sm">
      <li
        v-for="group in groups"
        :key="group.Id"
        class="faq-group"
        role="presentation"
      >
        <a
          :class="linkClasses(group)"
          href="#"
          @click.prevent="select($event, group)"
        >
          {{ group.Name }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import selectArrow from '@Shared/img/select-arrow.png'

export default {
  props: {
    groups: { type: Array, default: null },
    selectedGroup: { type: Object, default: null }
  },
  data () {
    return {
      localSelectedGroup: null,
      selectArrow
    }
  },
  watch: {
    localSelectedGroup (v) {
      this.$emit('group-selected', v)
    },
    selectedGroup (v) {
      this.localSelectedGroup = this.selectedGroup
    }
  },
  methods: {
    linkClasses (group) {
      return {
        'faq-group-link': true,
        'faq-group-link--selected': this.selectedGroup !== null && this.selectedGroup.Id === group.Id
      }
    },
    select (event, group) {
      event.preventDefault()
      this.$emit('group-selected', group)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../shared/scss/_select.scss';

.faq {
  &-groups {
    width: 100%;
    margin-bottom: 10px;
  }

  &-group {
    display: inline-block;
    padding: 0 10px;

    &-link {
      color: $grad-color-purple;
      font-weight: bold;
      font-family: $font-open-sans;
      font-size: 12px;
      text-transform: uppercase;

      &:hover {
        text-decoration: none;
        border-bottom: 2px solid $grad-color-purple;
      }

      &--selected {
        color: #000;

        &:hover {
          border-color: #000;
        }
      }
    }

    &__select {
      &-wrap {
        margin-bottom: 20px;
      }

      @include select();
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/home/faq/components/Groups.vue